import React, { useRef } from 'react';
import { Row, Col } from 'antd';
import CustomInput from '../../../../../../components/CustomInput';
import LogosUploader from '../../../../../../components/LogosUploader/LogosUploader';
import { countryCodesMap } from '../../../../../../shared/data/countryCodesMap';

export default function DetailsCompanyInfoInputs({
    flag,
    onChange,
    data,
    onFileSelect,
    logos,
    logoErrors,
    onDeleteLogo,
    onChangeCompanyInfo,
    dataStore,
    onLogosSizesChange,
}) {
    const uploadBigLogoButtonRefSV = useRef(null);
    const uploadBigLogoButtonRefNO = useRef(null);
    const uploadBigLogoButtonRefFI = useRef(null);
    const uploadBigLogoButtonRefDA = useRef(null);
    const uploadBigLogoButtonRefIS = useRef(null);
    const uploadSmallLogoButtonRefSV = useRef(null);
    const uploadSmallLogoButtonRefNO = useRef(null);
    const uploadSmallLogoButtonRefFI = useRef(null);
    const uploadSmallLogoButtonRefDA = useRef(null);
    const uploadSmallLogoButtonRefIS = useRef(null);
    const uploadFaviconButtonRefSV = useRef(null);
    const uploadFaviconButtonRefNO = useRef(null);
    const uploadFaviconButtonRefFI = useRef(null);
    const uploadFaviconButtonRefDA = useRef(null);
    const uploadFaviconButtonRefIS = useRef(null);
    const uploadEmailLogoButtonRefSV = useRef(null);
    const uploadEmailLogoButtonRefNO = useRef(null);
    const uploadEmailLogoButtonRefFI = useRef(null);
    const uploadEmailLogoButtonRefDA = useRef(null);
    const uploadEmailLogoButtonRefIS = useRef(null);

    const refsMap = {
        sv: {
            bigLogoButtonRef: uploadBigLogoButtonRefSV,
            smallLogoButtonRef: uploadSmallLogoButtonRefSV,
            faviconButtonRef: uploadFaviconButtonRefSV,
            emailLogoButtonRef: uploadEmailLogoButtonRefSV,
        },
        no: {
            bigLogoButtonRef: uploadBigLogoButtonRefNO,
            smallLogoButtonRef: uploadSmallLogoButtonRefNO,
            faviconButtonRef: uploadFaviconButtonRefNO,
            emailLogoButtonRef: uploadEmailLogoButtonRefNO,
        },
        fi: {
            bigLogoButtonRef: uploadBigLogoButtonRefFI,
            smallLogoButtonRef: uploadSmallLogoButtonRefFI,
            faviconButtonRef: uploadFaviconButtonRefFI,
            emailLogoButtonRef: uploadEmailLogoButtonRefFI,
        },
        da: {
            bigLogoButtonRef: uploadBigLogoButtonRefDA,
            smallLogoButtonRef: uploadSmallLogoButtonRefDA,
            faviconButtonRef: uploadFaviconButtonRefDA,
            emailLogoButtonRef: uploadEmailLogoButtonRefDA,
        },
        is: {
            bigLogoButtonRef: uploadBigLogoButtonRefIS,
            smallLogoButtonRef: uploadSmallLogoButtonRefIS,
            faviconButtonRef: uploadFaviconButtonRefIS,
            emailLogoButtonRef: uploadEmailLogoButtonRefIS,
        },
    };

    return (
        <div className="details-table">
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Company name
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`company_name_${countryCodesMap[flag]}`}
                                placeholder="Enter company name"
                                onInputChange={(e) => {
                                    onChange(e, countryCodesMap[flag]);
                                    onChangeCompanyInfo(e, flag);
                                }}
                                inputValue={data?.[flag]?.company_name}
                                width="100%"
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Service name
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`service_name_${countryCodesMap[flag]}`}
                                placeholder="Enter service name"
                                onInputChange={(e) => {
                                    onChange(e, countryCodesMap[flag]);
                                    onChangeCompanyInfo(e, flag);
                                }}
                                inputValue={data?.[flag]?.service_name}
                                width="100%"
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Title service name
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`title_service_name_${flag}`}
                                placeholder="Enter title service name"
                                onInputChange={(e) => {
                                    onChange(e, countryCodesMap[flag]);
                                    onChangeCompanyInfo(e, flag);
                                }}
                                inputValue={
                                    data?.[flag]?.title_service_name ||
                                    data?.[flag]?.service_name
                                }
                                width="100%"
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Full company name
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <CustomInput
                                className="input-dark"
                                id={`company_full_name_${countryCodesMap[flag]}`}
                                placeholder="Enter full company name"
                                onInputChange={(e) => {
                                    onChange(e, countryCodesMap[flag]);
                                    onChangeCompanyInfo(e, flag);
                                }}
                                inputValue={data?.[flag]?.company_full_name}
                                width="100%"
                            />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="details-table__row">
                <Row>
                    <Col span={7}>
                        <div className="details-table__row-head details-table__cell">
                            Logos
                        </div>
                    </Col>
                    <Col span={17}>
                        <div className="details-table__cell details-table__cell--editable">
                            <LogosUploader
                                onFileSelect={(e, flag) => {
                                    onFileSelect(e, flag);
                                    refsMap[
                                        flag
                                    ].bigLogoButtonRef.current.value = '';
                                    refsMap[
                                        flag
                                    ].smallLogoButtonRef.current.value = '';
                                    refsMap[
                                        flag
                                    ].faviconButtonRef.current.value = '';
                                    refsMap[
                                        flag
                                    ].emailLogoButtonRef.current.value = '';
                                }}
                                onLogosSizesChange={(e) =>
                                    onLogosSizesChange(e, countryCodesMap[flag])
                                }
                                bigLogo={logos[countryCodesMap[flag]]?.bigLogo}
                                smallLogo={
                                    logos[countryCodesMap[flag]]?.smallLogo
                                }
                                favicon={logos[countryCodesMap[flag]]?.favicon}
                                emailLogo={
                                    logos[countryCodesMap[flag]]?.emailLogo
                                }
                                bigLogoErrors={
                                    logoErrors[countryCodesMap[flag]]
                                        ?.bigLogoErrors
                                }
                                smallLogoErrors={
                                    logoErrors[countryCodesMap[flag]]
                                        ?.smallLogoErrors
                                }
                                faviconErrors={
                                    logoErrors[countryCodesMap[flag]]
                                        ?.faviconErrors
                                }
                                emailLogoErrors={
                                    logoErrors[countryCodesMap[flag]]
                                        ?.emailLogoErrors
                                }
                                onDeleteLogo={onDeleteLogo}
                                bigLogoButtonRef={
                                    refsMap[countryCodesMap[flag]]
                                        ?.bigLogoButtonRef
                                }
                                smallLogoButtonRef={
                                    refsMap[countryCodesMap[flag]]
                                        ?.smallLogoButtonRef
                                }
                                faviconButtonRef={
                                    refsMap[countryCodesMap[flag]]
                                        ?.faviconButtonRef
                                }
                                emailLogoButtonRef={
                                    refsMap[countryCodesMap[flag]]
                                        ?.emailLogoButtonRef
                                }
                                logosSizes={dataStore?.logos_sizes}
                                flag={countryCodesMap[flag]}
                                isFaviconEnabled={true}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
